import { Component, OnInit, inject, model } from '@angular/core';

import { FormatService } from '../../../services';

@Component({
  selector: 'app-report-header-standard-text',
  templateUrl: './report-header-standard-text.component.html',
  styleUrl: './report-header-standard-text.component.css',
})
export class ReportHeaderStandardTextComponent implements OnInit {
  private readonly formatService = inject(FormatService);

  public readonly model = model<any>();

  protected htmlStandardText: string;

  ngOnInit() {
    this.htmlStandardText = this.formatService.multiLineToHtml(this.model()?.standardText);
  }
}
